module.exports = __webpack_public_path__ + "img/1455917087.0fef7b55.jpg";